const styles = {
  rowEllipsis: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  nameMaxWidth: {
    maxWidth: '190px',
  },
  cuitMaxWidth: {
    maxWidth: '100px',
  },
  chip: {
    minWidth: '100px',
  },
};

export default styles;
